import React from 'react';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const StyledGrid = styled(Grid)(({ noPadding }) => ({
  padding: noPadding ? '0 !important' : '0 15px !important',
}));

function ItemGrid({ children, noPadding, className, xs, sm, md, lg, xl, ...rest }) {
  const sizeProps = {};
  if (xs !== undefined) sizeProps.xs = xs;
  if (sm !== undefined) sizeProps.sm = sm;
  if (md !== undefined) sizeProps.md = md;
  if (lg !== undefined) sizeProps.lg = lg;
  if (xl !== undefined) sizeProps.xl = xl;
  return (
    <StyledGrid noPadding={noPadding} className={className} size={sizeProps} {...rest}>
      {children}
    </StyledGrid>
  );
}

ItemGrid.defaultProps = {
  noPadding: false,
};

ItemGrid.propTypes = {
  noPadding: PropTypes.bool,
  xs: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sm: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  md: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lg: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  xl: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ItemGrid;